export default function AboutData() {
    return {
        title: "About Medicare",
        content:
            "Medicare is the government-run health insurance program for people age 65 and older, those under 65 with certain disabilities and those with end-stage renal disease. Care is provided by any doctor or facility that accepts Medicare.",
    }
}